module.exports = __webpack_public_path__ + "img/Crustacean.938fe5dd.jpg";